<h3 class="panel-title">
  <span>Files</span>
</h3>

<div class="chipster-highlight">
  <!-- workflow and files tabs -->

  <ch-search-box
    placeholder="Find file"
    focusHotkey="f"
    focusHotkeyDescription="Find file"
    (valueChange)="search($event)"
    (enterKey)="searchEnter()"></ch-search-box>

  <nav ngbNav #nav="ngbNav" class="nav-tabs">
    <!-- Workflow tab-->
    <ng-container ngbNavItem>
      <a ngbNavLink>Workflow</a>
      <ng-template ngbNavContent>
        <div id="workflow-graph-panel">
          <div class="mt-3 mb-1">
            <ch-add-dataset-modal [sessionData]="sessionData"></ch-add-dataset-modal>

            <!-- context dropdown -->
            <div ngbDropdown container="body" class="d-inline-block float-end">
              <button
                type="button"
                class="btn btn-sm btn-outline-secondary tool-bar-button no-caret-dropdown"
                id="viewDropdownMenuButton"
                ngbDropdownToggle
                aria-haspopup="true"
                aria-expanded="false"
                title="Actions">
                <!-- <i class="fa-solid fa-bars" aria-hidden="true"></i> -->
                <i class="fas fa-lg fa-ellipsis-h" aria-hidden="true"></i>
              </button>
              <div ngbDropdownMenu aria-labelledby="viewDropdownMenuButton">
                <button ngbDropdownItem (click)="selectAll()">Select all files</button>
                <button ngbDropdownItem (click)="selectChildren()" [class.disabled]="!isDatasetsSelected()">
                  Select descendants of selected files
                </button>
                <div class="dropdown-divider"></div>

                <button ngbDropdownItem (click)="autoLayoutAll()">Reset all positions</button>
                <button ngbDropdownItem (click)="autoLayoutSelected()" [class.disabled]="!isDatasetsSelected()">
                  Reset positions of selected files
                </button>
                <button ngbDropdownItem (click)="workflowGraph.resetZoomAndScroll()">Reset view</button>
              </div>
            </div>

            <!-- zoom buttons-->
            <button
              [disabled]="sessionData.datasetsMap.size === 0"
              class="btn btn-sm btn-outline-secondary me-2 float-end tool-bar-button"
              title="Zoom in"
              (click)="workflowGraph.zoomIn()">
              <span class="fa fa-lg fa-search-plus"></span>
            </button>
            <button
              [disabled]="sessionData.datasetsMap.size === 0"
              class="btn btn-sm btn-outline-secondary me-1 float-end tool-bar-button"
              title="Zoom out"
              (click)="workflowGraph.zoomOut()">
              <span class="fas fa-lg fa-search-minus"></span>
            </button>

            <!-- labels split button -->
            <div
              ngbDropdown
              #labelsDropdown="ngbDropdown"
              container="body"
              class="btn-group btn-group-sm float-end me-2">
              <button
                type="button"
                class="btn btn-outline-secondary tool-bar-button"
                [disabled]="!splitButtonLabel || !isDatasetsSelected()"
                [title]="splitButtonLabel ? 'Apply or remove \'' + splitButtonLabel.name + '\'' : 'Labels'"
                (click)="applySplitButtonLabel()">
                <i class="fas fa-lg fa-tags" aria-hidden="true" [style.color]="labelsButtonIconColor"></i>
              </button>
              <button
                type="button"
                class="btn btn-outline-secondary dropdown-toggle-split tool-bar-button"
                ngbDropdownToggle
                aria-haspopup="true"
                aria-expanded="false"
                title="Labels menu"></button>
              <div ngbDropdownMenu>
                @if (labelMenuItems.length > 0) {
                  @for (item of labelMenuItems; track item.label.labelId) {
                    <button ngbDropdownItem [disabled]="!isDatasetsSelected()" (click)="toggleLabel(item)">
                      <ch-label-menu-item-content [item]="item"></ch-label-menu-item-content>
                    </button>
                  }
                  <div class="dropdown-divider"></div>
                }
                <button ngbDropdownItem (click)="manageLabels()">Edit labels&hellip;</button>
                <div
                  class="dropdown-submenu position-relative"
                  (mouseenter)="selectByLabelOpen = labelMenuItems.length > 0"
                  (mouseleave)="selectByLabelOpen = false">
                  <button
                    ngbDropdownItem
                    class="d-flex justify-content-between align-items-center"
                    [disabled]="labelMenuItems.length === 0">
                    <span>Select files by label</span>
                    <span aria-hidden="true" class="ms-3">&rsaquo;</span>
                  </button>
                  @if (selectByLabelOpen) {
                    <div class="dropdown-menu show" style="position: absolute; left: 100%; top: 0; margin-left: 0">
                      @for (item of labelMenuItems; track item.label.labelId) {
                        <button
                          ngbDropdownItem
                          [disabled]="!item.inUseInSession"
                          (click)="selectFilesWithLabel(item); labelsDropdown.close()">
                          <span
                            class="d-inline-block align-middle"
                            style="width: 0.6em; height: 0.6em; border-radius: 50%; margin-right: 0.5em"
                            [style.background]="item.colorBg"></span>
                          <span>{{ item.label.name }}</span>
                        </button>
                      }
                    </div>
                  }
                </div>
                <div class="dropdown-divider"></div>
                <button ngbDropdownItem (click)="workflowGraph.toggleLabelDisplayMode()">
                  {{ workflowGraph.labelDisplayMode === "dots" ? "Show label names" : "Hide label names" }}
                </button>
                <button ngbDropdownItem (click)="workflowGraph.toggleLabelPanel()">
                  {{ workflowGraph.showLabelPanel ? "Hide labels panel" : "Show labels panel" }}
                </button>
              </div>
            </div>
          </div>

          <div>
            <ch-workflow-graph
              id="workflow-graph"
              #workflowGraph
              [datasetsMap]="sessionData.datasetsMap"
              [jobsMap]="sessionData.jobsMap"
              [modulesMap]="modulesMap"
              [datasetSearch]="datasetSearch"
              [defaultScale]="1"
              [enabled]="true"
              [sessionData]="sessionData"
              [tools]="tools"></ch-workflow-graph>
          </div>
        </div>
      </ng-template>
    </ng-container>

    <!-- List tab-->
    <ng-container ngbNavItem>
      <a ngbNavLink>List</a>

      <ng-template ngbNavContent>
        <div class="mt-3 ms-1 mb-2">
          <ch-add-dataset-modal [sessionData]="sessionData"></ch-add-dataset-modal>
        </div>

        <div id="file-list" class="p-0">
          <div class="list-group dataset-list list-group-sm pt-0">
            @for (dataset of getDatasetListSorted() | datasetsearch: datasetSearch; track dataset.datasetId) {
              <button
                type="button "
                class="dataset-list-button list-group-item list-group-item-action"
                [ngClass]="{
                  active: selectionService.isSelectedDatasetById(dataset.datasetId),
                }"
                (click)="toggleDatasetSelection($event, dataset)">
                {{ dataset.name }}
              </button>
            }
          </div>
        </div>
      </ng-template>
    </ng-container>
  </nav>

  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>
